import React, { useState, useEffect } from 'react';
import { Modal, Form, Switch, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { uploadBase } from '../../../../util/tool';
import { orderPurchaseSaveBillConfig, orderPurchaseBillConfig } from '../../api';

const ALLOWED_IMAGE_TYPES = ['jpg', 'jpeg', 'png'];
const UPLOAD_CONFIG = {
  maxSize: 2 * 1024 * 1024,
  accept: ALLOWED_IMAGE_TYPES.join(','),
  tipText: `${ALLOWED_IMAGE_TYPES.join('、')}格式，大小不超过2M`,
  errorMsg: `上传文件要求：格式${ALLOWED_IMAGE_TYPES.join('、')}，大小不超过2M!`
};
const FORM_DEFAULT_VALUES = {
  auto_confirm_bill: 1
};

export default function BillAutoConfirmSetting() {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [signFileList, setSignFileList] = useState([]);
  const AUTO_CONFIRM_BILL = Form.useWatch('auto_confirm_bill', form);

  useEffect(() => {
    async function fetchData() {
      const { data: { data, code } } = await orderPurchaseBillConfig();
      if (+code === 0) {
        if (data.signature_file !== '') {
          setSignFileList(JSON.parse(data.signature_file));
        }
        form.setFieldsValue({
          auto_confirm_bill: data.auto_confirm_bill,
        });
      }
    }
    fetchData();
  }, [form]);


  const signFileBeforeUpload = (file) => {
    const { size, name } = file;
    const isSizeValid = size <= UPLOAD_CONFIG.maxSize;

    if (!isSizeValid) {
      message.error(UPLOAD_CONFIG.errorMsg);
      return Upload.LIST_IGNORE;
    }

    const fileType = name.split('.').pop()?.toLowerCase();
    if (!fileType || !ALLOWED_IMAGE_TYPES.includes(fileType)) {
      message.error(`文件格式不正确，仅支持 ${ALLOWED_IMAGE_TYPES.join('、')} 格式!`);
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const signFileChange = async (currentFile) => {
    const currentItem = await uploadBase(currentFile);
    setSignFileList([currentItem]);
    form.setFieldsValue({ signature_file: currentItem });
    // message.success('电子签章上传成功!');
  };

  const handleFileRemove = () => {
    setSignFileList([]);
    form.setFieldsValue({ signature_file: undefined });
  };

  const onFinish = async (values) => {
    const { auto_confirm_bill } = values;
    const { data: { code, msg } } = await orderPurchaseSaveBillConfig({ auto_confirm_bill, signature_file: signFileList });

    if (+code === 0) {
      message.success(msg, .5, () => {
        setVisible(false);
      });
    }
  };

  const handleModalCancel = () => {
    setVisible(false);
    // form.resetFields();
    // setSignFileList([]);
  };


  return (
    <>
      <Button type="primary" onClick={() => setVisible(prev => !prev)} style={{ marginBottom: 8 }}>账单自动确认设置</Button>

      <Modal open={visible} title="账单自动确认设置" footer={null} onCancel={handleModalCancel} maskClosable={false}>
        <Form onFinish={onFinish} name='signature_file_form' form={form} initialValues={FORM_DEFAULT_VALUES}>
          <Form.Item label="对账单生成后自动确认账单" name='auto_confirm_bill' rules={[{ required: true, message: "请设置是否自动确认账单", type: "number" }]} valuePropName="checked">
            <Switch checked={AUTO_CONFIRM_BILL === 1} checkedChildren="开启" unCheckedChildren="关闭" style={{ fontSize: 14 }} onChange={(checked) => { form.setFieldsValue({ auto_confirm_bill: checked ? 1 : 0 }); }} />
          </Form.Item>
          {AUTO_CONFIRM_BILL === 1 ? <Form.Item required label="电子签章" name='signature_file' rules={[{ validator: (_, value) => { if (!signFileList?.length || !value) { return Promise.reject(new Error('请上传电子签章!')); } return Promise.resolve(); } }]}>
            <Upload name="file" headers={{ token: localStorage.getItem('token') }} listType="picture-card" customRequest={(file) => signFileChange(file)} beforeUpload={signFileBeforeUpload} accept={UPLOAD_CONFIG.accept} fileList={signFileList} onRemove={handleFileRemove} showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }}>
              {!signFileList?.length ? <>
                <div>
                  <div><UploadOutlined />上传</div>
                  <div style={{ fontSize: 12 }}>要求：{UPLOAD_CONFIG.tipText}</div>
                </div>
              </> : null}
            </Upload>
          </Form.Item> : null}
          <Form.Item style={{ textAlign: 'center', marginTop: 20 }}>
            <Button type="primary" htmlType="submit">保存</Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}